"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ncoToCsv = void 0;
const transformerUtils_1 = require("./transformerUtils");
exports.ncoToCsv = (ncoJson, options = {}) => {
    const filenamePrefix = !!(options === null || options === void 0 ? void 0 : options.filenamePrefix) ? `${options.filenamePrefix}_` : '';
    const skipHeaders = !!(options === null || options === void 0 ? void 0 : options.skipHeaders);
    const encloseCSVColumn = (str) => {
        return `"${str.toString().replace(/"/g, "'")}"`;
    };
    const variablesSharingSameShape = transformerUtils_1.getVariablesSharingSameShape(ncoJson);
    return Object.keys(variablesSharingSameShape).map((shapeString) => {
        const variables = variablesSharingSameShape[shapeString];
        const { headers, rows } = transformerUtils_1.getDataFromVariablesSharingSameShapeDuplicateRows({
            variables,
            ncoJson,
            order: options.order || 'ASC',
        });
        const globalAtributes = Object.keys(ncoJson.attributes || {})
            .filter((attrName) => !['history', 'history_of_appended_files'].includes(attrName))
            .map((attrName) => { var _a; return `# ${attrName},${encloseCSVColumn(((_a = ncoJson.attributes) === null || _a === void 0 ? void 0 : _a[attrName]) || 'null')}`; });
        const globalAtributesRows = globalAtributes.join('\n');
        const varibleKeysForAttributeHeaders = variables.reduce((prev, variableKey) => [...prev, ...ncoJson.variables[variableKey].shape, variableKey], []);
        const allAttributeNames = [
            ...new Set(varibleKeysForAttributeHeaders.reduce((prev, variableKey) => {
                var _a;
                const attributes = Object.keys(((_a = ncoJson.variables[variableKey]) === null || _a === void 0 ? void 0 : _a.attributes) || {});
                return [...prev, ...attributes];
            }, [])),
        ].filter((attrName) => !['scale_factor', 'add_offset'].includes(attrName));
        const cvsHeaderMeta = allAttributeNames.map((attrName) => {
            const attributeValuesForEachColumn = headers.map((header) => { var _a, _b; return encloseCSVColumn(((_b = (_a = ncoJson.variables[header.label]) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b[attrName]) || 'null'); });
            return `# ${attrName},${attributeValuesForEachColumn.join(',')}`;
        });
        const cvsHeaderMetaRows = cvsHeaderMeta.join('\n');
        const csvHeaderRow = ',' + headers.map((header) => header.label).join(',');
        const csvRowsDataOnly = rows
            .map((row) => {
            return ',' + row.map((current) => current === null || current === void 0 ? void 0 : current.toString()).join(',');
        })
            .join(`\n`);
        const csvRowsWithHeaders = [globalAtributesRows, cvsHeaderMetaRows, csvHeaderRow, csvRowsDataOnly].filter((str) => !!str).join('\n');
        return {
            filename: `${filenamePrefix}${shapeString}.csv`,
            fileContent: skipHeaders ? csvRowsDataOnly : csvRowsWithHeaders,
        };
    });
};
